const MainMenu = {

    // FIELDS
    "name": "الاسم",
    "description": "الوصف",
    "menu_icon": 'أيقونة',
    "status": "الحالة",
    "priority": "الأولوية",
    "search": "بحث",

    // PAGE HEADER
    "main_menu": "القائمة الرئيسية",

    // ERROR
    "error_name": "الرجاء إدخال الاسم",
    "error_desc": "الرجاء إدخال الوصف",
    "error_status": "الرجاء تحديد الحالة",
    "error_priority_positive": "يجب أن تكون الأولوية إيجابية",
    "error_priority_required": "الرجاء إدخال الأولوية",
    "error_priority_type_error": "الرجاء إدخال أرقام فقط",
    "error_icon": "أدخل اسم الرمز",

    // TABLE HEADER
    "table_name": "الاسم",
    "table_description": "الوصف",
    "table_priority": "الأولوية",
    "table_status": "الحالة",

}

export default MainMenu;